/* eslint-disable no-underscore-dangle */
import { action, observable, computed } from 'mobx';
import { DateTime } from 'luxon';
import type CatalogStore from 'stores/Catalog';
import PremiumSessionFilterStore from 'stores/PremiumSessionFilter';
import { PremiumSession, PremiumSessionState } from 'types/premiumSession';

class LiveSessionsStore {
  @observable _currentPage = 1;

  @observable entriesPerPage = 10;

  @observable ready = false;

  catalogStore: CatalogStore;

  premiumSessionFilterStore: PremiumSessionFilterStore;

  constructor(
    catalogStore: CatalogStore,
    premiumSessionFilterStore: PremiumSessionFilterStore,
  ) {
    this.catalogStore = catalogStore;
    this.premiumSessionFilterStore = premiumSessionFilterStore;
  }

  // eslint-disable-next-line class-methods-use-this
  @action filterForScheduledSessionFilters = (s: PremiumSession) => {
    if (!s) {
      return false;
    }
    return (
      DateTime.fromISO(s.start_time) >= DateTime.now() &&
      s?.state === PremiumSessionState.Scheduled
    );
  };

  @computed get livePremiumSessions() {
    return this.premiumSessionFilterStore?.filteredSessionContentEntries || [];
  }

  @computed get paginatedEntries() {
    const startIndex = (this.currentPage - 1) * this.entriesPerPage;
    return this.livePremiumSessions.slice(
      startIndex,
      startIndex + this.entriesPerPage,
    );
  }

  @computed get totalCount() {
    return this.livePremiumSessions?.length || 0;
  }

  @computed get totalPages() {
    return (
      Math.ceil(this.livePremiumSessions.length / this.entriesPerPage) || 1
    );
  }

  @computed get currentPage() {
    if (this._currentPage > this.totalPages) {
      return 1;
    }

    return this._currentPage;
  }

  @action setCurrentPage = (page = 1) => {
    this._currentPage = page;
  };
}

export default LiveSessionsStore;
